<!--
 * @Author: liuxiaoyan
 * @Date: 2021-10-11 16:30:23
 * @LastEditors: zhaohaozhuang
 * @LastEditTime: 2024-05-08 17:02:08
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <div class="container">
    <fourVision v-if=" FourVersionEnum.includes(versionType)" :versionType="versionType"></fourVision>
    <new-vision v-else-if="NewVersionEnum.includes(versionType)"  :isNewVersion ="NewVersionEnum.includes(versionType)" :versionType="versionType"></new-vision>
    <new-package v-else-if="TwoVersionEnum.includes(versionType)" :isShowBasic="isShowBasic" :versionType="versionType" ></new-package>
    <old-package v-else :versionType="versionType" ></old-package>
  </div>
</template>
<script>
import newPackage from './newPackage';
import oldPackage from './oldPackage';
import newVision from './newVision';
import fourVision from './fourVision.vue'
export default {
  name: 'renew_packages',
  data() {
    return {
      isNewVersion:false,
      isNormalVersion: false,
      isShowBasic: false,
      FourVersionEnum:['MARKET','EDU','NEWLEAD','SENIOR','PEAK'],
      NewVersionEnum:['UNKNOWN', 'NEWBASIC', 'LEAD', 'ENJOY', 'NEWSPORT'],
      TwoVersionEnum:['BASIC','NEWADVANCED','SPECIALTY','NEWCHAIN','SPORT','AESTHETIC'],
      VersionEnum:['STANDARD', 'ADVANCED', 'ULTIMATE', 'CHAIN'],
      versionType:""
    };
  },
  methods: {
    judgeVersion() {
      const query = {
        instId: window.getParameterByName('instId'),
      };
      axios
        .post('business/anon/inst/getCurrentSaasBasicType', query)
        .then(res => {
          const { result } = res;
          this.isShowBasic = result === 'BASIC';
          this.versionType = result;
        })
        .catch(e => {});
    },
  },
  computed: {},
  // 判断机构是4.0还是5.0
  created() {
    this.judgeVersion();
  },
  mounted() {},
  components: {
    newPackage,
    oldPackage,
    newVision,
    fourVision
  },
};
</script>

<style lang="less">
.container {
  height: 100vh;
  overflow: scroll;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/module/renew/packages.vue